import React, { useEffect, useState } from 'react';

import axios from 'axios';

import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import 'moment/locale/ko';
import PgmItemComponent from '../components/Pgm/PgmItemComponent';
import PgmVersionComponent from '../components/Pgm/PgmVersionComponent';
import PgmVersionRegisterComponent from '../components/Pgm/PgmVersionRegisterComponent';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import Box from '@mui/material/Box';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import Divider from '@mui/material/Divider';

import Cookies from 'js-cookie';
import { useRecoilState } from 'recoil';
import { authAtom } from '../_state';

export default function PgmList({ hideTitle = false, readOnly = false }) {
  const [datas, setDatas] = useState([]);
  const [versionRegisterOpen, setVersionRegisterOpen] = useState(false);
  const [versionOpen, setVersionOpen] = useState(false);
  const [versionId, setVersionId] = useState('');
  const [versionState, setVersionState] = useState('');
  const [pgmNm, setPgmNm] = useState('');
  const [mediaUrl, setMediaUrl] = useState('');
  const [open, setOpen] = useState(false);
  const [mediaName, setMediaName] = useState('');
  const [noticeList, setNoticeList] = useState([]);
  const [auth, setAuth] = useRecoilState(authAtom);

  const handleVersionOpen = () => setVersionOpen(true);
  const handleVersionClose = () => setVersionOpen(false);

  const handleVersionRegisterOpen = () => setVersionRegisterOpen(true);
  const handleVersionRegisterClose = () => setVersionRegisterOpen(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const getDataList = async (e) => {
    const response = await axios.get(`/api/pgm`, { params: { viewYn: true, kind: 'public' } });
    setDatas(response.data);
  };

  const getValidNotice = async (e) => {
    const response = await axios.get(`/api/board/validNotice`);
    setNoticeList(response.data);
  };

  useEffect(() => {
    getValidNotice();
    getDataList();
  }, []);

  useEffect(() => {
    getDataList();
  }, [auth]);

  return (
    <>
      <Paper sx={{ p: 2, display: 'flex', flexDirection: 'column', alignItems: 'center', alignContent: 'center' }}>
        {!hideTitle && (
          <Typography component="h2" variant="h6" color="primary" gutterBottom>
            제품 목록 (활성화 코드로 모든 프로그램 사용 가능)
          </Typography>
        )}
        <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }} justifyContent="center" alignItems="center" sx={{ maxWidth: 1500, alignContent: 'center' }}>
          {datas.map((data, rowIdx) => (
            <Grid item xs="auto">
              <PgmItemComponent
                id={data.id}
                engNm={data.engNm}
                korNm={data.korNm}
                ver={data.ver}
                downloadCnt={data.downloadCnt}
                totalCnt={data.totalCnt}
                readOnly={readOnly}
                thumbnailImgName={data.thumbnailImgName}
                fileName={data.fileName}
                manualName={data.manualName}
                mediaUrl={data.mediaUrl}
                versionId={data.versionId}
                handleOpen={handleOpen}
                setMediaName={setMediaName}
                setMediaUrl={setMediaUrl}
                handleVersionOpen={handleVersionOpen}
                setPgmNm={setPgmNm}
                setVersionId={setVersionId}
                setVersionState={setVersionState}
                handleVersionRegisterOpen={handleVersionRegisterOpen}
              />
            </Grid>
          ))}
        </Grid>
      </Paper>
      <Dialog open={open} onClose={handleClose} aria-labelledby="draggable-dialog-title" maxWidth="800">
        <DialogTitle id="draggable-dialog-title">{mediaName}</DialogTitle>
        <DialogContent dividers>
          <Box sx={{ mt: 3 }}>
            <iframe src={mediaUrl} width="900" height="600" allowfullscreen="true"></iframe>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button variant="outlined" color="success" onClick={handleClose}>
            닫기
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog open={versionOpen} onClose={handleVersionClose} aria-labelledby="draggable-dialog-title" maxWidth="800">
        <DialogTitle id="draggable-dialog-title">{pgmNm} 버전 내역</DialogTitle>
        <DialogContent dividers sx={{ height: 800, overflowY: 'auto' }}>
          <Box sx={{ mt: 3 }}>
            <PgmVersionComponent id={versionId} handleVersionRegisterOpen={handleVersionRegisterOpen} handleVersionClose={handleVersionClose} setVersionState={setVersionState} getDataList={getDataList} setVersionId={setVersionId} readOnly={readOnly} />
          </Box>
        </DialogContent>
        <DialogActions>
          <Button variant="outlined" color="success" onClick={handleVersionClose}>
            닫기
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={versionRegisterOpen} onClose={handleVersionRegisterClose} aria-labelledby="draggable-dialog-title" maxWidth="800">
        <DialogTitle id="draggable-dialog-title">
          {pgmNm} 버전 내역 {versionState == 'register' ? '등록' : '수정'}
        </DialogTitle>
        <DialogContent dividers>
          <Box sx={{ mt: 3 }}>
            <PgmVersionRegisterComponent
              id={versionId}
              pgmNm={pgmNm}
              state={versionState}
              handleVersionOpen={handleVersionOpen}
              handleVersionRegisterClose={handleVersionRegisterClose}
              getDataList={getDataList}
              setVersionId={setVersionId}
            />
          </Box>
        </DialogContent>
        <DialogActions>
          <Button variant="outlined" color="success" onClick={handleVersionRegisterClose}>
            닫기
          </Button>
        </DialogActions>
      </Dialog>

      {noticeList.map((notice) => (
        <NoticeDialog subject={notice.subject} content={notice.content} id={notice.id} />
      ))}
    </>
  );
}

const NoticeDialog = (props) => {
  const { subject, content, id } = props;
  const [oepn, setOpen] = useState();

  const noticeClose = () => setOpen(false);

  const expiresClose = async (expiresDate) => {
    let expires = new Date();
    expires.setDate(expires.getDate() + expiresDate);
    console.log(expires);
    Cookies.set(`hasVisitedBefore_${id}`, expires.getTime(), { expires: expires });
    noticeClose();
  };

  useEffect(() => {
    const HAS_VISITED_BEFORE = Cookies.get(`hasVisitedBefore_${id}`);
    if (HAS_VISITED_BEFORE && HAS_VISITED_BEFORE > new Date()) {
      setOpen(false);
    } else {
      setOpen(true);
    }
  }, []);

  return (
    <Dialog open={oepn} onClose={noticeClose} aria-labelledby="draggable-dialog-title" maxWidth="800">
      <DialogTitle id="draggable-dialog-title">{subject}</DialogTitle>
      <DialogContent dividers>
        <Box component="div" sx={{ ml: 1, mt: 1, maxHeight: 700, width: 1000 }}>
          <Divider />
          <Box component="div" dangerouslySetInnerHTML={{ __html: content }} sx={{ minHeight: 400, maxHeight: 700, overflowY: 'scroll' }} />
          <Divider />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" color="error" onClick={() => expiresClose(7)}>
          1주일간 보지 않기
        </Button>
        <Button variant="outlined" color="secondary" onClick={() => expiresClose(1)}>
          오늘 하루 보지 않기
        </Button>
        <Button variant="outlined" color="success" onClick={noticeClose}>
          닫기
        </Button>
      </DialogActions>
    </Dialog>
  );
};
